import { SCREENS, type ScreenId } from "./screens/types";

export function Nav({ current, onSelect }: { current: ScreenId; onSelect: (id: ScreenId) => void }) {
  return (
    <nav className="tabs">
      {SCREENS.map((s) => (
        <button
          key={s.id}
          type="button"
          className={current === s.id ? "active" : ""}
          onClick={() => onSelect(s.id)}
        >
          {s.label}
        </button>
      ))}
    </nav>
  );
}
